import DescriptionIcon from "@material-ui/icons/Description.js";
import ChromeReaderModeIcon from '@material-ui/icons/ChromeReaderMode';
import PeopleAltIcon from "@material-ui/icons/PeopleAlt.js";
import {RouteNames} from "../../router/consts.js";
import PhonelinkSetupIcon from "@material-ui/icons/PhonelinkSetup.js";
import WorkIcon from "@material-ui/icons/Work.js";
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import FolderOpenIcon from "@material-ui/icons/FolderOpen.js";
import BarChartIcon from '@material-ui/icons/BarChart';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import React from "react";

export const sideBarButtons = {
    act: {label: 'Просмотр актов', icon: <DescriptionIcon/>, route: RouteNames.HOME},
    library: {label: 'Библиотека документов', icon: <ChromeReaderModeIcon/>, route: RouteNames.LIBRARY},
    users: {label: 'Пользователи', icon: <PeopleAltIcon/>, route: RouteNames.USERS},
    devices: {label: 'Мобильные устройства', icon: <PhonelinkSetupIcon/>, route: RouteNames.DEVICES},
    projects: {label: 'Проекты', icon: <WorkIcon/>, route: RouteNames.PROJECTS},
    normativeDocuments: {
        label: 'Нормативные документы',
        icon: <FolderOpenIcon/>,
        route: RouteNames.NORMATIVE_DOCUMENTS
    },
    charts: {label: 'КПЭ', icon: <BarChartIcon/>, route: RouteNames.CHART_PAGE},
    podr: {label: 'перейти к подрядчикам', icon: <SupervisedUserCircleIcon />, route: RouteNames.PODR_PAGE},
    dataLens: {label: 'перейти к аналитике', icon: <ShowChartIcon />, route: RouteNames.DATA_LENS},
    tests: {label: 'Тестирование', icon: <TextFieldsIcon />, route: RouteNames.TESTS}
}